import React, { useState, useCallback } from 'react'
import img1 from '../assests/gallery/Manimuthar-Falls-2.webp'
import img2 from '../assests/gallery/Tiger-Reserve-1.webp'
import img3 from '../assests/gallery/Old-Temple-Tirunelveli.webp'
import img4 from '../assests/gallery/shutterstock_1504345622-2.webp'
import img5 from '../assests/gallery/destinations-to-relax-with-family-in-tamil-nadu.avif'
import img6 from '../assests/gallery/Gandhi-memorial-kanyakumari.webp'
import img7 from '../assests/gallery/GqqlBokXgAApNw7.jpg'
import img8 from '../assests/gallery/Papanasam_Waterfall.jpg'
import img9 from '../assests/gallery/Papanasam_Waterfall (1).jpg'
import img10 from '../assests/gallery/Suchindram-temple.webp'
import img11 from '../assests/gallery/Thamirabarani_River_@_Agasthiyar_Falls.jpg'
import img12 from '../assests/gallery/karaiyar-dam.jpg'
import img13 from '../assests/gallery/places-to-visit-in-kanyakumari-1.webp'
import img14 from '../assests/gallery/504004673_1006500164976864_879791875085642835_n.jpg'
import img15 from '../assests/gallery/images.jfif'

export default function Gallery(){
  const images = [img1,img2,img3,img4,img5,img6,img7,img8,img9,img10,img11,img12,img13,img14,img15]
  const [open, setOpen] = useState(false)
  const [current, setCurrent] = useState(0)

  const openAt = useCallback((index) => {
    setCurrent(index)
    setOpen(true)
  }, [])

  const close = useCallback(() => setOpen(false), [])

  const prev = useCallback(() => setCurrent(c => (c - 1 + images.length) % images.length), [images.length])
  const next = useCallback(() => setCurrent(c => (c + 1) % images.length), [images.length])

  return (
    <main className="container">
      <h1>Photo Gallery</h1>
      <p className="lead">A selection of photos that attracts the tourists.</p>
      <div className="gallery">
        {images.map((src, i) => (
          <img key={i} src={src} alt={`Travel photo ${i+1}`} onClick={() => openAt(i)} />
        ))}
      </div>

      {open && (
        <div className="lightbox" role="dialog" aria-modal="true" onClick={close}>
          <button className="lightbox-close" onClick={close} aria-label="Close">✕</button>
          <button className="lightbox-prev" onClick={(e)=>{e.stopPropagation(); prev()}} aria-label="Previous">‹</button>
          <div className="lightbox-inner" onClick={(e)=>e.stopPropagation()}>
            <img src={images[current]} alt={`Preview ${current+1}`} />
          </div>
          <button className="lightbox-next" onClick={(e)=>{e.stopPropagation(); next()}} aria-label="Next">›</button>
        </div>
      )}
    </main>
  )
}
